import Form from './src/form';
import FormItem from './src/form-item';

module.exports = {
    Form,FormItem
}


// WEBPACK FOOTER //
// ./src/components/form/index.js